import React, { useEffect, useRef, useState } from "react";
import BreadcrumbSection from "../../../components/BreadcrumbSection";
import {
  Button,
  Col,
  Container,
  Image,
  ListGroup,
  Nav,
  Row,
  Card,
  Spinner,
  Form,
} from "react-bootstrap";
import IMAGES from "../../../constants/images";
import { Icon } from "@iconify/react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { BsHeart, BsHeartFill } from "react-icons/bs";
import AccordionComponent from "../../../components/AccordionComponent";
import PricingCards from "../../../components/PricingCards";
import ReviewsComponent from "../../../components/ReviewsComponent";
import CommonModal from "components/CommonModal";
import { stripHtmlTags } from "utils/helpers";
import { fetchProductBySlug } from "api/ProductService";
import { useAuth } from "context/UserContext";
import { toast } from "react-toastify";
import { Sentry } from "react-activity";
import {
  toggleFavorite,
  followUser,
  checkFollowStatus,
  getMyProductSupportWithoutLimit,
} from "api/ActivityService";
import { useParams } from "react-router-dom";
import { addCommentReview } from "api/ReviewService";
import RatingStars from "components/RatingStars";
import ReactShowMoreText from "react-show-more-text";
import { Modal, Image as RBImage } from "react-bootstrap";
// Add this import at the top with other imports
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CollapsibleText from "components/CollapsibleText";
import Loader from "components/Loader";
// Add this schema definition before the component
const addToListSchema = yup.object().shape({
  listOption: yup.string().required("Please select an option"),
  existingList: yup.string().when("listOption", {
    is: "existing",
    then: () => yup.string().required("Please select a list"),
    otherwise: () => yup.string().nullable(),
  }),
  newListName: yup.string().when("listOption", {
    is: "new",
    then: () =>
      yup
        .string()
        .trim()
        .required("List name is required")
        .min(1, "List name cannot be empty"),
    otherwise: () => yup.string().nullable(),
  }),
});

const ProductDetails = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Product Overview");
  const [pageLoading, setPageLoading] = useState(true);
  const [followStatus, setFollowStatus] = useState("Follow"); // can be 'follow', 'followback', or 'unfollow'
  const [saving, setSaving] = useState(false);
  const [following, setFollowing] = useState(false);
  const [is_disabled, setIsDisabled] = useState(false);
  const [supportLists, setSupportLists] = useState([]);
  const { slug } = useParams();
  const [selectedList, setSelectedList] = useState("");
  const location = useLocation();
  // const catData = location.state?.catData;
  // const pathName = location.state?.pathName;
  const { isLoggedIn, user } = useAuth();
  const userId = user ? user._id : "";
  const [productData, setProductData] = useState("");
  const productId = productData?._id || productData?.id;
  const {
    handleSubmit,
    register,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addToListSchema),
    defaultValues: {
      listOption: "existing",
      existingList: supportLists[0]?._id || "",
      newListName: "",
    },
  });

  const listOption = watch("listOption");

  const handleAddToList = async (data) => {
    try {
      if (!isLoggedIn) {
        toast.error("Please login first to add favorites.");
        return;
      }

      setIsDisabled(true);

      let listId;
      if (data.listOption === "existing") {
        listId = data.existingList;
        const payload = {
          productId: productId,
          listId: listId,
        };
        const res = await toggleFavorite(payload);
        console.log("res", res);
        if (res.success) {
          toast.success("Product added to list successfully");
          setShow("");
          setIsDisabled(false);
          reset();
          fetchData(); // Refresh lists
        } else {
          toast.error(res.message || "Failed to add to list");
          setIsDisabled(false);
        }
      } else {
        const payload = {
          productId: productId,
          name: data.newListName,
        };
        const res = await toggleFavorite(payload);
        if (res.success) {
          setSupportLists(res.body.data);
          toast.success("Product added to list successfully");
          setShow("");
          setIsDisabled(false);
          reset();
          fetchData(); // Refresh lists
        } else {
          toast.error(res.message || "Failed to add to list");
          setIsDisabled(false);
        }
      }
    } catch (err) {
      console.error("Error adding to list:", err);
      toast.error(err.message || "Failed to add to list");
      setIsDisabled(false);
    }
  };

  // Section references for smooth scrolling
  const sectionRefs = {
    "Product Overview": useRef(null),
    Pricing: useRef(null),
    Media: useRef(null),
    "Company Info": useRef(null),
    Reviews: useRef(null),
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sectionRefs[tab]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const navRef = useRef(null);

  useEffect(() => {
    if (navRef.current) {
      navRef.current.style.scrollbarWidth = "none"; // Firefox
      navRef.current.style.overflowX = "auto";
      navRef.current.style.whiteSpace = "nowrap";
    }
  }, []);

  const fetchData = async () => {
    try {
      if (!slug) return;
      const res = await fetchProductBySlug({ slug, userId });
      if (res.success) {
        setProductData(res.body);
        setPageLoading(false);
      } else {
        navigate("/not-found");
      }
    } catch (error) {
      console.error("Failed to fetch product details", error);
    }
  };
  const openFavModal = async () => {
    if (!isLoggedIn) {
      toast.error("Please login first to add favorites.");
      return;
    }
    if (supportLists.length == 0) {
      try {
        setPageLoading(true);
        const res = await getMyProductSupportWithoutLimit();
        if (res.success) {
          const supportData = res.body.data;
          setSupportLists(supportData);
          setPageLoading(false);
        }
      } catch (error) {
        console.error("Failed to fetch product details", error);
      }
    }
    setShow(true);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const handleToggleFavorite = async (productId) => {
  //   try {
  //     if (!isLoggedIn) {
  //       toast.error("Please login first to add favorites.");
  //       return;
  //     }
  //     const payload = {
  //       productId: productId,
  //     };
  //     const res = await toggleFavorite(payload); // your API call function
  //     if (res.success) {
  //       fetchData();
  //     }
  //   } catch (err) {
  //     console.error("Error toggling favorite:", err);
  //   }
  // };

  useEffect(() => {
    if (productData?.userId?._id && userId) {
      checkFollow();
    }
  }, [productData?.userId?._id, userId]);

  const checkFollow = async () => {
    if (!userId || !productData?.userId?._id) return;

    try {
      const res = await checkFollowStatus(userId, productData?.userId._id);
      if (res.success) {
        setFollowStatus(res.body); // 'follow', 'followback', 'unfollow'
      }
    } catch (error) {
      console.error("Error checking follow status:", error);
    }
  };

  const handleFollowToggle = async () => {
    if (!isLoggedIn) {
      toast.error("Please login to follow.");
      return;
    }

    try {
      const res = await followUser(productData?.userId._id);
      if (res.success) {
        // toast.success("Updated follow status.");
        checkFollow(); // Refresh button state
      }
    } catch (error) {
      console.error("Follow error:", error);
      toast.error("Failed to update follow status.");
    }
  };

  // ✅ Inside ProductDetails component
  const [previewUrl, setPreviewUrl] = useState(null);
  const [playingVideoUrl, setPlayingVideoUrl] = useState(null);
  const mediaUrls = productData?.mediaUrls || [];
  const [show, setShow] = useState("");

  const getMediaUrl = (mediaUrls) => {
    //return non video url
    return mediaUrls.find((url) => !url.includes(".mp4"));
  };
  return pageLoading ? (
    <div className="loaderdiv">
      {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
      <Loader />
    </div>
  ) : (
    <React.Fragment>
      {/* BreadCrumb Section */}
      <BreadcrumbSection
        breadcrumbs={[
          { title: productData.name }, // No link because it's active
          // {
          //   title: catData?.title,
          //   link: pathName,
          //   state: { resource: catData },
          // },
        ]}
      />
      <section className="product_section">
        <Image
          src={getMediaUrl(productData?.mediaUrls)}
          alt=""
          className="newimg-fluid"
        />
        <Container>
          <Row>
            <Col lg={12}>
              <div className="product__header">
                {/* <div
                    className="product__header__iconBox"
                  // style={{
                  //   backgroundColor: "#FFDDE2",
                  // }}
                  > */}
                <div
                  className="product__header__iconBox"
                  style={{
                    border: "6px solid white",
                    borderRadius: "21px",
                    backgroundColor: productData.brandColors || "#ffffff",
                  }}
                >
                  <Image
                    src={productData?.logoUrl}
                    alt={productData.name}
                    className="img-fluid"
                    style={{ width: 100, height: 100 }}
                  />
                </div>
                <div className="product_contentBox">
                  <div className="product_content">
                    <div className="product_content_flex">
                      <div className="d-flex align-items-start gap-2 mb-1 title">
                        <h2 style={{ textAlign: "left" }}>
                          {productData?.name} (
                          {productData?.userId?.companyName})
                        </h2>
                        <Button
                          className="follow show_laptop"
                          variant={
                            followStatus === "Unfollow"
                              ? "danger"
                              : followStatus === "Followback"
                              ? "outline-primary"
                              : "info"
                          }
                          size="sm"
                          onClick={async () => {
                            if (following) return;
                            setFollowing(true);
                            await handleFollowToggle();
                            setFollowing(false);
                          }}
                        >
                          {following ? (
                            <Spinner animation="border" size="sm" />
                          ) : followStatus === "Unfollow" ? (
                            "Unfollow"
                          ) : followStatus === "Followback" ? (
                            "Follow Back"
                          ) : (
                            "Follow"
                          )}
                        </Button>
                      </div>
                      <div className="product_rating">
                        <RatingStars rating={Number(productData?.avgRating)} />{" "}
                        <div className="total_review_text">
                          ({productData?.totalReviews}) {productData?.avgRating}{" "}
                          out of 5{" "}
                        </div>
                        {user?.role === "vendor" && (
                          <>
                            {" "}
                            {/* <span className="divider1">|</span>{" "} */}
                            <span
                              className="discussion mt-1"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigate("/community", {
                                  state: { resource: productData },
                                })
                              }
                            >
                              Discussion
                            </span>
                          </>
                        )}
                      </div>
                    </div>

                    {(!user || user?.role === "user") && (
                      <div className="d-flex flex-column align-items-end gap-2  show_tab follow_btn_section">
                        <Button
                          className="follow  show_tab"
                          variant={
                            followStatus === "Unfollow"
                              ? "danger"
                              : followStatus === "Followback"
                              ? "outline-primary"
                              : "info"
                          }
                          size="sm"
                          onClick={async () => {
                            if (following) return;
                            setFollowing(true);
                            await handleFollowToggle();
                            setFollowing(false);
                          }}
                        >
                          {following ? (
                            <Spinner animation="border" size="sm" />
                          ) : followStatus === "Unfollow" ? (
                            "Unfollow"
                          ) : followStatus === "Followback" ? (
                            "Follow Back"
                          ) : (
                            "Follow"
                          )}
                        </Button>
                        <Button
                          className=" show_tab align-items-center justify-content-center contact_btn"
                          style={{ height: "33px" }}
                          variant="outline-danger"
                          onClick={() => {
                            window.open(productData?.websiteUrl, "_blank");
                          }}
                        >
                          <Icon
                            icon="mingcute:contacts-3-fill"
                            fontSize={25}
                            className="me-2"
                          />
                          Contact
                        </Button>
                      </div>
                    )}
                    {(!user || user?.role === "user") && (
                      <div className="d-flex align-items-end  gap-2 flex-column follow_btn_section show_laptop">
                            <Button
                         className="follow "
                         variant={
                           followStatus === "Unfollow"
                             ? "danger"
                             : followStatus === "Followback"
                             ? "outline-primary"
                             : "info"
                         }
                         size="sm"
                         onClick={async () => {
                           if (following) return;
                           setFollowing(true);
                           await handleFollowToggle();
                           setFollowing(false);
                         }}
                       >
                         {following ? (
                           <Spinner animation="border" size="sm" />
                         ) : followStatus === "Unfollow" ? (
                           "Unfollow"
                         ) : followStatus === "Followback" ? (
                           "Follow Back"
                         ) : (
                           "Follow"
                         )}
                       </Button>
                      <Button
                        className=" ms-2 show_laptop align-items-center justify-content-center contact_btn"
                        variant="outline-danger"
                        style={{height: "33px"}}
                        onClick={() => {
                          window.open(productData?.websiteUrl, "_blank");
                        }}
                      >
                        <Icon
                          icon="mingcute:contacts-3-fill"
                          fontSize={25}
                          className="me-2"
                        />
                        Contact
                       {/* <span className="">{`Contact ${productData?.name.slice(0, 10)}...`}</span> */}
                      </Button>
                      </div>
                    )}
                  </div>
                  {(!user || user?.role === "user") && (
                    <div className="d-flex align-items-center justify-content-between gap-2  show_tab show_laptop save_btn_section">
                      <Button
                        variant="link"
                        style={{ fontSize: "14px" }}
                        className="d-flex align-items-center text-secondary fw-normal font14 text-decoration-none p-0"
                        // onClick={async () => {
                        //   if (saving) return;
                        //   setSaving(true);
                        //   await handleToggleFavorite(
                        //     productData?._id || productData?.id
                        //   );
                        //   setSaving(false);
                        // }}
                        onClick={() => openFavModal()}
                      >
                        <>
                          {saving ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <BsHeart className="text-muted me-2" size={20} />
                          )}
                          Save to My List
                        </> 
                      </Button>
                      <div className="d-flex align-items-center gap-2 ">
                        {productData?.pricing?.length > 0 && (
                          <Button
                            variant="outline-danger"
                            style={{ fontSize: "14px" }}
                            className="ms-0 ms-md-auto px-3 border-radius-100"
                          >
                            Entry Level Price:
                            <span className="text-primary">
                              {" "}
                              {Math.min(
                                ...productData.pricing.map(
                                  (p) => parseFloat(p?.price) || 0
                                )
                              ) === 0
                                ? "$ Free"
                                : `$${Math.min(
                                    ...productData.pricing.map(
                                      (p) => parseFloat(p?.price) || 0
                                    )
                                  ).toFixed(2)}`}
                            </span>
                          </Button>
                        )}

                        <Button
                          variant="info"
                          style={{ fontSize: "14px" }}
                          className="border-radius-100 px-4"
                          onClick={() => {
                            window.open(productData?.websiteUrl, "_blank");
                          }}
                        >
                          Try For Free
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {(!user || user?.role === "user") && (
                <div className="show_mobile d-flex save_btn_section flex-column align-items-center justify-content-between gap-3 mb-3">
                  <div className="d-flex align-items-center gap-2 justify-content-between flex_item">
                    <Button
                      variant="link"
                      className="d-flex align-items-center text-secondary fw-normal font14 text-decoration-none p-0"
                      // onClick={async () => {
                      //   if (saving) return;
                      //   setSaving(true);
                      //   await handleToggleFavorite(
                      //     productData?._id || productData?.id
                      //   );
                      //   setSaving(false);
                      // }}
                      onClick={() => openFavModal()}
                    >
                      <>
                        {saving ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <BsHeart className="text-muted me-2" size={20} />
                        )}
                        Save to My List
                      </>
                    </Button>
                    <Button
                      style={{ height: "40px" }}
                      className="follow"
                      variant={
                        followStatus === "Unfollow"
                          ? "danger"
                          : followStatus === "Followback"
                          ? "outline-primary"
                          : "info"
                      }
                      size="sm"
                      onClick={async () => {
                        if (following) return;
                        setFollowing(true);
                        await handleFollowToggle();
                        setFollowing(false);
                      }}
                    >
                      {following ? (
                        <Spinner animation="border" size="sm" />
                      ) : followStatus === "Unfollow" ? (
                        "Unfollow"
                      ) : followStatus === "Followback" ? (
                        "Follow Back"
                      ) : (
                        "Follow"
                      )}
                    </Button>
                    <Button
                      className="contact_btn"
                      style={{ height: "33px" }}
                      variant="outline-danger"
                      onClick={() => {
                        window.open(productData?.websiteUrl, "_blank");
                      }}
                    >
                      <Icon
                        icon="mingcute:contacts-3-fill"
                        fontSize={25}
                        className="me-2"
                      />
                      Contact
                    </Button>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2 w-100">
                    {productData?.pricing?.length > 0 && (
                      <Button
                        variant="outline-danger"
                        style={{ height: "40px", fontSize: "14px" }}
                        className="ms-0 ms-md-auto px-3 border-radius-100"
                      >
                        Entry Level Price:
                        <span className="text-primary">
                          {" "}
                          {Math.min(
                            ...productData.pricing.map(
                              (p) => parseFloat(p?.price) || 0
                            )
                          ) === 0
                            ? "$ Free"
                            : `$${Math.min(
                                ...productData.pricing.map(
                                  (p) => parseFloat(p?.price) || 0
                                )
                              ).toFixed(2)}`}
                        </span>
                      </Button>
                    )}

                    <Button
                      variant="info"
                      style={{ height: "40px" }}
                      className="border-radius-100 px-4"
                      onClick={() => {
                        window.open(productData?.websiteUrl, "_blank");
                      }}
                    >
                      Try For Free
                    </Button>
                  </div>
                </div>
              )}
              <div className="nav_Flex show_tab show_laptop margin_tab">
                <div className="scroll-container" ref={navRef}>
                  <Nav
                    variant="tabs"
                    className="flex-nowrap"
                    defaultActiveKey="Product Overview"
                  >
                    {[
                      "Product Overview",
                      "Pricing",
                      "Media",
                      "Company Info",
                      "Reviews",
                    ].map((tab) => (
                      <Nav.Item key={tab}>
                        <Nav.Link
                          eventKey={tab}
                          active={activeTab === tab}
                          onClick={() => handleTabClick(tab)}
                          style={{
                            backgroundColor:
                              activeTab === tab ? "#E91515" : "transparent",
                            color: activeTab === tab ? "white" : "black",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            outline: "none",
                          }}
                        >
                          {tab}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </div>
                {isLoggedIn && user?.role === "user" && (
                  <div className="d-flex gap-4 helpFull show_tab show_laptop">
                    <Link
                      to={"/community"}
                      className="text-decoration-none blueColor d-flex align-items-center "
                      state={{
                        resource: productData,
                      }}
                    >
                      <Icon
                        icon="hugeicons:user-question-02"
                        fontSize={20}
                        className="me-2"
                      />{" "}
                      Community
                    </Link>
                    <Link
                      to={"/disputes"}
                      state={{ productId, title: productData.name, slug }}
                      className="text-decoration-none redColor d-flex align-items-center"
                    >
                      <Icon
                        icon="bx:comment-error"
                        fontSize={22}
                        className="me-2"
                      />{" "}
                      Disputes
                    </Link>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div  className="nav_Flex w-100 show_mobile">
        <div className=" w-100" ref={navRef}>
          <Nav
            variant="tabs"
            className="flex-nowrap"
            defaultActiveKey="Product Overview"
          >
            {[
              "Product Overview",
              "Pricing",
              "Media",
              "Company Info",
              "Reviews",
            ].map((tab) => (
              <Nav.Item key={tab}>
                <Nav.Link
                  eventKey={tab}
                  active={activeTab === tab}
                  onClick={() => handleTabClick(tab)}
                  style={{
                    backgroundColor:
                      activeTab === tab ? "#E91515" : "transparent",
                    color: activeTab === tab ? "white" : "black",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    outline: "none",
                  }}
                >
                  {tab}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>
    
      </div>
      {isLoggedIn && user?.role === "user" && (
        <div
          className="d-flex gap-4 helpFull show_mobile"
        >
          <Link
            style={{ width: "100%", justifyContent: "center", padding: "0.75rem 0" }}
            to={"/community"}
            className="text-decoration-none text-center blueColor d-flex align-items-center justify-content-center"
            state={{
              resource: productData,
            }}
          >
            <Icon
              icon="hugeicons:user-question-02"
              fontSize={20}
              className="me-2"
            />{" "}
            Community
          </Link>
          <Link
            style={{
              width: "100%",
              justifyContent: "center",
              padding: "0.75rem 0",
            }}
            to={"/disputes"}
            state={{ productId, title: productData.name, slug }}
            className="text-decoration-none text-center redColor d-flex align-items-center justify-content-center"
          >
            <Icon icon="bx:comment-error" fontSize={22} className="me-2" />{" "}
            Disputes
          </Link>
        </div>
      )}
      <section
        className="product_overview bg-light"
        ref={sectionRefs["Product Overview"]}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <h2 className="h2Common">{productData?.name} Overview</h2>
              {/* <Card.Text className="seemorepara" as="div">
                <ReactShowMoreText
                  lines={2}
                  more="See more"
                  less="See less"
                  anchorClass="see-more-link"
                  expanded={false}
                  width={0}
                >
                  {productData?.description}
                </ReactShowMoreText>
              </Card.Text> */}

              {/* <h3 className="mb-2">Product Description</h3> */}
              <Card.Text className="para">
                {/* <CollapsibleText  lines={5} bgColor="#f8f9fa"> */}
                <div
                  dangerouslySetInnerHTML={{ __html: productData?.description }}
                  style={{
                    whiteSpace: "pre-wrap",
                    lineHeight: "1.6",
                    marginBottom: "1rem",
                  }}
                />
                {/* </CollapsibleText> */}
              </Card.Text>

              <h3 className="mb-0">Other Details</h3>
              <Row className="mb-4">
                <Col lg={6}>
                  <ListGroup
                    className="customListGroup"
                    style={{ maxWidth: "530px" }}
                  >
                    {productData?.websiteUrl && (
                      <ListGroup.Item>
                        <Icon icon="gg:website" fontSize={24} />
                        <span>
                          <strong>Product Website</strong> (
                          <Link
                            to={productData.websiteUrl}
                            style={{ wordBreak: "break-all" }}
                          >
                            {productData.websiteUrl}
                          </Link>
                          )
                        </span>
                      </ListGroup.Item>
                    )}

                    {productData?.marketSegment?.length > 0 && (
                      <ListGroup.Item>
                        <Icon icon="ph:line-segments" fontSize={24} />
                        <span>
                          <strong>Market Segment</strong> (
                          {productData.marketSegment
                            .map((item) => item?.title)
                            .join(", ")}
                          )
                        </span>
                      </ListGroup.Item>
                    )}

                    {productData?.languages?.length > 0 && (
                      <ListGroup.Item>
                        <Icon icon="iconoir:language" fontSize={24} />
                        <span>
                          <strong>Languages</strong> (
                          {productData.languages
                            .map((item) => item?.title)
                            .join(", ")}
                          )
                        </span>
                      </ListGroup.Item>
                    )}
                  </ListGroup>
                </Col>

                <Col lg={6}>
                  <ListGroup className="customListGroup">
                    {productData?.whoCanUse?.length > 0 && (
                      <ListGroup.Item>
                        <Icon icon="tabler:users" fontSize={24} />
                        <span>
                          <strong>Users</strong> (
                          {productData.whoCanUse
                            .map((item) => item?.title)
                            .join(", ")}
                          )
                        </span>
                      </ListGroup.Item>
                    )}

                    {productData?.industries?.length > 0 && (
                      <ListGroup.Item>
                        <Icon icon="clarity:building-line" fontSize={24} />
                        <span>
                          <strong>Industries</strong> (
                          {productData.industries
                            .map((item) => item?.title)
                            .join(", ")}
                          )
                        </span>
                      </ListGroup.Item>
                    )}

                    {/* Example placeholder, update discussion logic if needed */}
                    {/* <ListGroup.Item>
                      <Icon icon="fluent:chat-16-regular" fontSize={24} />
                      <span>
                        <strong>Discussion</strong> (
                        <Link to={""}>
                          Marketing & Advertising, IT and Services
                        </Link>
                        )
                      </span>
                    </ListGroup.Item> */}
                  </ListGroup>
                </Col>
              </Row>

              {productData?.features.length > 0 && (
                <>
                  {" "}
                  <h3>Features</h3>
                  <AccordionComponent features={productData?.features || []} />
                </>
              )}
              {productData?.integrations.length > 0 && (
                <>
                  {" "}
                  <h3 className="mt-4">Integrations</h3>
                  <div
                    className="integradionFlex"
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(150px, 1fr))",
                      gap: "1rem",
                      "@media (max-width: 768px)": {
                        gridTemplateColumns: "repeat(2, 1fr)",
                      },
                    }}
                  >
                    {productData?.integrations?.map((integration, index) => (
                      <div key={index} className="shadowCard">
                        <Card className="text-center">
                          <Card.Body>
                            <Image
                              src={integration?.mediaUrl}
                              alt={integration?.title}
                              style={{ width: "70px", height: "70px" }}
                            />
                          </Card.Body>
                        </Card>
                        <Card.Footer className="text-center">
                          {integration?.name}
                        </Card.Footer>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Container>
      </section>
      <section className="product_overview">
        <Image src={IMAGES.Lines_IMG} className="lines_pos" alt="" />
        <Container>
          <Row>
            <Col lg={12}>
              {productData?.pricing?.length > 0 && (
                <>
                  {" "}
                  <h2 className="h2Common" ref={sectionRefs["Pricing"]}>
                    {productData?.name} Pricing
                  </h2>
                  {/* <Card.Text className="para">
                
                {stripHtmlTags(productData?.description)?.slice(0, 100)}...
              </Card.Text> */}
                  <PricingCards
                    websiteUrl={productData?.websiteUrl}
                    plans={productData?.pricing || []}
                  />
                </>
              )}
              <h2 className="h2Common mb-4" ref={sectionRefs["Media"]}>
                {productData?.name} Media
              </h2>
              {productData?.mediaUrls?.length > 0 ? (
                <>
                  <div className="media-grid">
                    {/* Large left card (spans 2 rows) */}
                    <Card
                      className="collage-card large media-large"
                      onClick={() => {
                        const url = productData.mediaUrls[0];
                        if (url?.toLowerCase().endsWith(".mp4")) {
                          setPlayingVideoUrl(url);
                        } else {
                          setPreviewUrl(url);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {productData?.mediaUrls?.[0]
                        ?.toLowerCase()
                        .endsWith(".mp4") ? (
                        <>
                          <video
                            key={
                              playingVideoUrl === productData.mediaUrls[0]
                                ? productData.mediaUrls[0]
                                : undefined
                            }
                            width="100%"
                            height="100%"
                            controls={
                              playingVideoUrl === productData.mediaUrls[0]
                            }
                            autoPlay={
                              playingVideoUrl === productData.mediaUrls[0]
                            }
                            muted
                            style={{
                              borderRadius: "0.5rem",
                              objectFit: "cover",
                              height: "100%",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <source
                              src={productData.mediaUrls[0]}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                          {playingVideoUrl !== productData.mediaUrls[0] && (
                            <div
                              className="playButton"
                              onClick={(e) => {
                                e.stopPropagation();
                                setPlayingVideoUrl(productData.mediaUrls[0]);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <Card.Img
                                variant="top"
                                src={IMAGES.Play_Circle}
                              />
                            </div>
                          )}
                        </>
                      ) : (
                        <Card.Img
                          variant="top"
                          src={productData.mediaUrls[0]}
                        />
                      )}
                    </Card>

                    {/* Top right card */}
                    {productData?.mediaUrls[1] && (
                      <Card
                        className="collage-card small media-small"
                        onClick={() => {
                          const url = productData.mediaUrls[1];
                          if (url?.toLowerCase().endsWith(".mp4")) {
                            setPlayingVideoUrl(url);
                          } else {
                            setPreviewUrl(url);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {productData.mediaUrls[1]
                          .toLowerCase()
                          .endsWith(".mp4") ? (
                          <>
                            <video
                              key={
                                playingVideoUrl === productData.mediaUrls[1]
                                  ? productData.mediaUrls[1]
                                  : undefined
                              }
                              width="100%"
                              height="100%"
                              controls={
                                playingVideoUrl === productData.mediaUrls[1]
                              }
                              autoPlay={
                                playingVideoUrl === productData.mediaUrls[1]
                              }
                              muted
                              style={{
                                borderRadius: "0.5rem",
                                objectFit: "cover",
                                height: "100%",
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <source
                                src={productData.mediaUrls[1]}
                                type="video/mp4"
                              />
                              Your browser does not support the video tag.
                            </video>
                            {playingVideoUrl !== productData.mediaUrls[1] && (
                              <div
                                className="playButton"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPlayingVideoUrl(productData.mediaUrls[1]);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <Card.Img
                                  variant="top"
                                  src={IMAGES.Play_Circle}
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <Card.Img
                            variant="top"
                            src={productData.mediaUrls[1]}
                          />
                        )}
                      </Card>
                    )}

                    {/* Bottom right card */}
                    {productData?.mediaUrls[2] && (
                      <Card
                        className="collage-card small media-small"
                        onClick={() => {
                          const url = productData.mediaUrls[2];
                          if (url?.toLowerCase().endsWith(".mp4")) {
                            setPlayingVideoUrl(url);
                          } else {
                            setPreviewUrl(url);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {productData.mediaUrls[2]
                          .toLowerCase()
                          .endsWith(".mp4") ? (
                          <>
                            <video
                              key={
                                playingVideoUrl === productData.mediaUrls[2]
                                  ? productData.mediaUrls[2]
                                  : undefined
                              }
                              width="100%"
                              height="100%"
                              controls={
                                playingVideoUrl === productData.mediaUrls[2]
                              }
                              autoPlay={
                                playingVideoUrl === productData.mediaUrls[2]
                              }
                              muted
                              style={{
                                borderRadius: "0.5rem",
                                objectFit: "cover",
                                height: "100%",
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <source
                                src={productData.mediaUrls[2]}
                                type="video/mp4"
                              />
                              Your browser does not support the video tag.
                            </video>
                            {playingVideoUrl !== productData.mediaUrls[2] && (
                              <div
                                className="playButton"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPlayingVideoUrl(productData.mediaUrls[2]);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <Card.Img
                                  variant="top"
                                  src={IMAGES.Play_Circle}
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <Card.Img
                            variant="top"
                            src={productData.mediaUrls[2]}
                          />
                        )}
                      </Card>
                    )}
                  </div>

                  <Row className="g-3 mt-1">
                    {productData?.mediaUrls.slice(3, 5).map((url, index) => {
                      const isVideo = url?.toLowerCase().endsWith(".mp4");
                      return (
                        <Col md={6} key={index}>
                          <Card
                            className={`collage-card ${
                              index === 1 ? "videoBox medium" : "medium"
                            }`}
                            onClick={() => {
                              if (isVideo) {
                                setPlayingVideoUrl(url);
                              } else {
                                setPreviewUrl(url);
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {isVideo ? (
                              <>
                                <video
                                  key={
                                    playingVideoUrl === url ? url : undefined
                                  }
                                  width="100%"
                                  height="100%"
                                  controls={playingVideoUrl === url}
                                  autoPlay={playingVideoUrl === url}
                                  muted
                                  style={{
                                    borderRadius: "0.5rem",
                                    objectFit: "cover",
                                    height: "100%",
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <source src={url} type="video/mp4" />
                                  Your browser does not support the video tag.
                                </video>
                                {playingVideoUrl !== url && (
                                  <div
                                    className="playButton"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setPlayingVideoUrl(url);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <Card.Img
                                      variant="top"
                                      src={IMAGES.Play_Circle}
                                    />
                                  </div>
                                )}
                              </>
                            ) : (
                              <Card.Img variant="top" src={url} />
                            )}
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              ) : (
                <p>No media available.</p>
              )}
            </Col>
          </Row>
        </Container>
      </section>
      <section className="product_overview" ref={sectionRefs["Company Info"]}>
        <Image src={IMAGES.Lines_IMG} className="lines_pos" alt="" />
        <Container>
          <Row className="mb-4">
            <Col lg={12}>
              <div className="d-flex align-items-center gap-4 mb-4">
                {productData?.userId?.companyLogo && (
                  <Image
                    src={productData?.userId?.companyLogo}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                    alt=""
                  />
                )}{" "}
                <h2 className="h2Common">{productData?.name} Company Info</h2>
              </div>
              <Card.Text className="para">
                {/* <CollapsibleText  lines={5} bgColor="rgb(255 255 255)"> */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: productData?.userId?.companyDescription,
                  }}
                  style={{
                    whiteSpace: "pre-wrap",
                    lineHeight: "1.6",
                    marginBottom: "1rem",
                    wordBreak: "break-word",
                  }}
                />
                {/* </CollapsibleText> */}
              </Card.Text>
              {/* <Card.Text className="para">
              <ReactShowMoreText
                        lines={4}
                        more="See more"
                        less="See less"
                        anchorClass="see-more-link"
                        expanded={false}
                        width={0}
                      >
                        {productData?.userId?.companyDescription}
                      </ReactShowMoreText>
              </Card.Text> */}
            </Col>
          </Row>
          <h3 className="mb-0 " style={{ marginTop: "2.5rem" }}>
            Seller Details
          </h3>
          <Row className="mb-4">
            <Col lg={6}>
              <ListGroup
                className="customListGroup"
                style={{ maxWidth: "530px" }}
              >
                {productData?.userId?._id && (
                  <ListGroup.Item>
                    <Icon icon="mdi:hand-coin-outline" fontSize={24} />
                    <span>
                      <strong>Seller</strong> (
                      <Link
                        to={
                          productData?.userId?._id === userId
                            ? `/vendor/myprofile`
                            : `/public-profile/${productData.userId._id}`
                        }
                      >
                        {productData.userId.companyName}
                      </Link>
                      )
                    </span>
                  </ListGroup.Item>
                )}

                {productData?.userId?.companyWebsiteUrl && (
                  <ListGroup.Item>
                    <Icon icon="gg:website" fontSize={22} />
                    <span>
                      <strong>Company Website</strong> (
                      <Link
                        to={productData.userId.companyWebsiteUrl}
                        target="_blank"
                      >
                        {productData.userId.companyWebsiteUrl}
                      </Link>
                      )
                    </span>
                  </ListGroup.Item>
                )}

                {productData?.userId?.yearFounded && (
                  <ListGroup.Item>
                    <Icon icon="stash:data-date" fontSize={24} />
                    <span>
                      <strong>Year Founded</strong> (
                      {productData.userId.yearFounded})
                    </span>
                  </ListGroup.Item>
                )}

                {productData?.userId?.hqLocation && (
                  <ListGroup.Item>
                    <Icon icon="mynaui:location" fontSize={24} />
                    <span>
                      <strong>HQ Location</strong> (
                      {productData.userId.hqLocation})
                    </span>
                  </ListGroup.Item>
                )}
              </ListGroup>
            </Col>

            <Col lg={6}>
              <ListGroup
                className="customListGroup"
                style={{ maxWidth: "530px" }}
              >
                {productData?.userId?.twitterProfileUrl && (
                  <ListGroup.Item>
                    <Icon icon="prime:twitter" fontSize={24} />
                    <span>
                      <strong>Twitter</strong> (
                      <Link
                        to={productData.userId.twitterProfileUrl}
                        target="_blank"
                      >
                        {productData.userId.twitterProfileUrl}
                      </Link>
                      )
                    </span>
                  </ListGroup.Item>
                )}

                {productData?.userId?.linkedInProfileUrl && (
                  <ListGroup.Item>
                    <Icon icon="mingcute:linkedin-line" fontSize={24} />
                    <span>
                      <strong>LinkedIn Page</strong> (
                      <Link
                        to={productData.userId.linkedInProfileUrl}
                        target="_blank"
                      >
                        {productData.userId.linkedInProfileUrl}
                      </Link>
                      )
                    </span>
                  </ListGroup.Item>
                )}

                {/* Assuming Ownership is static — you can conditionally check or leave as is */}
                <ListGroup.Item>
                  <Icon icon="solar:user-linear" fontSize={24} />
                  <span>
                    <strong>Ownership</strong> (
                    {productData?.userId?.displayName
                      ? productData?.userId?.displayName
                      : productData?.userId?.firstName +
                        " " +
                        productData?.userId?.lastName}
                    ){/* (NASDAQ: MNDY) */}
                  </span>
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className="product_section pro_pad bg-light"
        ref={sectionRefs["Reviews"]}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <div className="product__header">
                <div className="product_contentBox">
                  <div className="product_content">
                    <div className="product_content_flex w-100">
                      {/* <div className="mb-2"> */}
                      <h2 className="h2Common">{productData?.name} Reviews</h2>
                      {/* </div> */}
                      <div className="product_rating product_rating1 d-flex">
                        <RatingStars rating={Number(productData?.avgRating)} />{" "}
                        <div className="total_review_text">
                          {" "}
                          ({productData?.totalReviews}) {productData?.avgRating}{" "}
                          out of 5
                        </div>
                      </div>
                    </div>
                    {(!user || user.role === "user") && (
                      <Button
                        variant="danger"
                        className="mt-2"
                        onClick={() => {
                          if (!isLoggedIn) {
                            toast.error("Please login to write a review", {
                              toastId: "login-required",
                            });
                            return;
                          }
                          // navigate("/write-a-review");

                          const updatedChecked = [productData];

                          localStorage.setItem(
                            "checkedProducts",
                            JSON.stringify(updatedChecked)
                          );
                          localStorage.setItem("step", 2);
                          // window.open("/write-a-review", "_blank");
                          navigate("/write-a-review");
                        }}
                      >
                        Write A Review
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              <ReviewsComponent
                productData={productData}
                productId={productId}
                userId={userId}
              />
            </Col>
          </Row>
        </Container>
      </section>
      {/* ✅ Bootstrap Modal for Media Preview */}
      <Modal
        show={!!previewUrl}
        onHide={() => setPreviewUrl(null)}
        centered
        size="lg"
      >
        <Modal.Body className="text-center p-0">
          <RBImage src={previewUrl} fluid />
        </Modal.Body>
      </Modal>

      <CommonModal
        image
        paraStyle={{ maxWidth: "600px", marginTop: "10px" }}
        title=""
        para=""
        body={
          <div style={{ marginTop: "-40px" }}>
            <h3 className="text-start mb-4">Add to My List</h3>
            <Form onSubmit={handleSubmit(handleAddToList)}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="radio"
                  id="existing-list-option"
                  label="Choose from existing lists"
                  value="existing"
                  {...register("listOption")}
                />

                {listOption === "existing" && (
                  <Form.Select
                    className="mt-2"
                    {...register("existingList")}
                    disabled={is_disabled}
                  >
                    <option value="">Select List</option>
                    {supportLists.map((i) => (
                      <option key={i._id} value={i._id}>
                        {i.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
                {errors.existingList && (
                  <span className="text-danger mt-1 text-start d-block">
                    {errors.existingList.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Check
                  type="radio"
                  id="new-list-option"
                  label="Create new list"
                  value="new"
                  {...register("listOption")}
                />

                {listOption === "new" && (
                  <Form.Control
                    type="text"
                    placeholder="Enter new list name"
                    className="mt-2"
                    {...register("newListName")}
                    disabled={is_disabled}
                  />
                )}
                {errors.newListName && (
                  <span className="text-danger mt-1 text-start d-block">
                    {errors.newListName.message}
                  </span>
                )}
              </Form.Group>

              <Button
                type="submit"
                variant="info"
                className="w-100 border-radius-100 mt-3"
                disabled={is_disabled}
              >
                {is_disabled ? <Spinner animation="border" size="sm" /> : "Add"}
              </Button>
            </Form>
          </div>
        }
        show={show !== ""}
        onClose={() => {
          setShow("");
          reset();
        }}
      />
    </React.Fragment>
  );
};
export default ProductDetails;
